import { StyleSheet } from 'react-native';

import { blackTransparent } from 'utils/colors';
import { isTabletOrWeb, widthPercentageToDP } from 'utils/responsiveness';

import { ImageSize } from 'components/NagraImage/types';

const styles = StyleSheet.create({
    container: {
        width: ImageSize.PROFILE_IMAGE.width,
        height: ImageSize.PROFILE_IMAGE.width,
        alignSelf: 'center',
        marginBottom: 4,
    },
    logoOverlay: {
        ...StyleSheet.absoluteFillObject,
        borderRadius: ImageSize.PROFILE_IMAGE.width,
        backgroundColor: blackTransparent(0.5),
    },
    logoIcon: {
        position: 'absolute',
        top: isTabletOrWeb ? 39 : widthPercentageToDP(25),
        left: isTabletOrWeb ? 39 : widthPercentageToDP(25),
        zIndex: 1,
    },
});

export default styles;
